/************
 * List Tab Detail with right hand properties drawer
 * File Name ...: requesttypes.components.ts
 * Generated By : ianday on 12/12/23
 * Date ........: 12/12/23
 /************/

import {Component, OnInit, ViewChild, HostListener, AfterContentInit} from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import {MatSort} from '@angular/material/sort';
import {Settings} from '../../../services/settings';
import { ServiceRequestType} from "../../../models/service-request-type";
import { ServiceRequestsService } from "../../../services/service-requests.service";
import {ValidationResult} from '../../../models/validation-result';
import {
    ConfirmDialogComponent,
    ConfirmDialogModel
} from '../../../components/shared/confirmation-dialog/confirmation-dialog.component';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {TransactionHistoryService} from '../../../services/transactionhistory.service';
import {TransactionHistoryComponent} from '../../../components/transaction-history/transaction-history';
import {DwUtils} from '../../../components/utils/dw-utils';
import {RequestStatus} from "../../../models/request-status";
import {ServiceDefService} from "../../../services/servicedef.service";
import {Region} from "../../../models/region";

@Component({
    selector: 'app-master-regions',
    templateUrl: './master-regions.component.html',
    styleUrls: ['./master-regions.component.css']
})
export class MasterRegionsComponent implements OnInit, AfterContentInit {

    /*** Header / Query Strip Variables ****/
    public formTitle = 'Regions [Zips & Counties]';
    public pagination: string;

    /*** Editing variables ***/
    public isEditing: boolean | null = false;
    public isAdd: boolean | null = false;
    public records: any;
    public selectedRecord: any;
    public historyRecord: any;
    public Idx: number | null = -1;
    public strErr: string | null = '';
    public dataSource: MatTableDataSource<any>;
    public finalizeList: any;
    public result: boolean | null = false;
    public disabledFlag: boolean | null = true;


    /**** Query strip filter settings ***/
    public selectedStatusFilter: string | null = 'Active';
    public contentClassWithBanner: string | null = 'dwtable-container';
    public contentClassWithoutBanner: string | null = 'dwtable-container-without-header';
    public contentClassName: string | null = 'dwtable-container';

    /*** Record Table / card table  ***/
    public displayedColumns: string[] = ['id', 'description', 'zipCode', 'county'];

    /***** Control Strip Button Visibility ***/
    public visibleAdd: boolean | null = false;
    public visibleModify: boolean | null = false;
    public visibleDelete: boolean | null = false;

    /***** Tab Detail Section *****/
    public selectedTabIndex: number | null = 0;

    public id: any | null = '';
    public description: any | null = '';
    public zipCode: any | null = '';
    public county: any | null = '';
    public busyCursor: boolean = false;

    @ViewChild(MatSort, {static: true}) sort: MatSort;
    @ViewChild('history', {static: true}) history: TransactionHistoryComponent;

    constructor(private serviceDefService: ServiceDefService,
                private txService: TransactionHistoryService,
                public dialog: MatDialog) {
        this.selectedRecord = new Region();

    }

    ngOnInit() {
        if(Settings.getInstance().hasPrivilege("SETTINGS_REGIONS", "WRITE")) {
            this.visibleAdd = true;
            this.visibleModify = true;
            this.visibleDelete = false;
        }
    }

    ngAfterContentInit() {

        this.queryRecords();

        if (Settings.getInstance().enableMessageBanner) {
            this.contentClassName = this.contentClassWithBanner;
        } else {
            this.contentClassName = this.contentClassWithoutBanner;
        }
    }

    /*** Query Records from the Service ***/
    queryRecords() {
        this.busyCursor = true;
        this.serviceDefService.getAllRegions().subscribe(
            (result) => {
                this.busyCursor = false;
                this.records = result;
                this.dataSource = new MatTableDataSource(this.records);
                this.dataSource.sort = this.sort;

                this.setPagination(-1, this.dataSource.data.length);
                //this.onChangeStatusFilterValue();
            },
            (error) => {
                Settings.getInstance().handleError(error,'Error: unable to retrieve regions data from the service');
                this.busyCursor = false;
            }
        );
    }

    /*** Display the number of records from the total ***/
    setPagination(idx: number, total: number) {
        this.pagination = (idx + 1) + '/' + total;
    }

    onChangeStatusFilterValue() {
        const dataTemp: ServiceRequestType[] = [];
        this.clearFilter();

        for (const rec of this.records) {
            if (rec.activeStatus === this.selectedStatusFilter || this.selectedStatusFilter === 'All') {
                dataTemp.push(rec);
            }
        }
        this.dataSource = new MatTableDataSource(dataTemp);
        this.setPagination(-1, this.dataSource.filteredData.length);
    }

    onStatusChange() {

        this.serviceDefService.updateRegion(this.selectedRecord).subscribe(
            () => {
                // no user feedback, just apply the filter ...
                this.onChangeStatusFilterValue();
            });
    }

    doTabChange(): void {

    }

    @HostListener('matSortChange', ['$event'])
    onSortChange(event: any) {

        if (event.direction === 'asc') {
            if (event.active === 'id') {
                this.records.sort((a, b) =>
                    a[event.active] - (b[event.active]));
            }
            else {
                this.records.sort((a, b) =>
                    a[event.active].localeCompare(b[event.active]));
            }
        } else {
            if (event.active === 'id') {
                this.records.sort((a, b) =>
                    b[event.active] - (a[event.active]));
            }
            else {
                this.records.sort((a, b) =>
                    b[event.active].localeCompare(a[event.active]));
            }
        }

        this.dataSource.data = this.records;
        this.selectRow();
        this.setPagination(this.Idx, this.dataSource.filteredData.length);
    }

    clearFilter() {
        if (this.isEditing) {
            return;
        }
        this.unSelectRow();
        this.dataSource.filter = '';
        this.selectRow();
        this.setPagination(-1, this.dataSource.data.length);
    }

    applyFilter(filterValue: string) {
        if (this.isEditing) {
            return;
        }
        this.dataSource.filter = filterValue.trim().toLowerCase();
        this.unSelectRow();
        this.setPagination(this.Idx, this.dataSource.filteredData.length);
    }

    selectRow() {
        if (this.selectedRecord.id === 0) {
            this.unSelectRow();
            return;
        }
        this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
    }

    unSelectRow() {

        this.Idx = -1;
        this.selectedRecord = new ServiceRequestType();
        this.setPagination(this.Idx, this.dataSource.data.length);
        this.displayDetail(this.selectedRecord);

    }

    displayDetail(record: Region) {
        if (record === undefined) {
            return;
        }
        this.id = record.id;

        this.description = DwUtils.capitalize(record.description);
        this.zipCode = record.zipCode;
        this.county = record.county;
        this.history.onShowHandler('Regions', 'id', record.id.toString());
    }

    clear() {
        this.id = '';
        this.description = '';
        this.zipCode = '';
        this.county= '';
    }

    addModifyRecord(isAdd: boolean) {
        this.isAdd = isAdd;
        this.isEditing = true;
        this.selectedTabIndex = 0;

        if (this.isAdd) {
            this.clear();
            this.id = 0;

        } else {
            // store the history record
            this.historyRecord = this.selectedRecord;
        }

        DwUtils.setFocus('description');
    }

    removeRecord() {
        const message = 'Remove Request Status: "' + this.selectedRecord.description + '" - Are you sure?';
        const dialogData = new ConfirmDialogModel('Please Confirm', message);

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '400px',
            data: dialogData,
            panelClass: 'custom-dialog-container'
        });

        dialogRef.afterClosed().subscribe(dialogResult => {
            this.result = dialogResult;
            if (this.result === true) {
                this.serviceDefService.deleteRegion(this.selectedRecord.id).subscribe(
                    () => {
                        // remove the row from the table.

                        this.records.splice(this.Idx, 1);
                        this.dataSource.data = this.records;
                        this.clear();
                    },
                    (error) => {
                        Settings.getInstance().handleError(error);
                    });
            }
        });
    }

    tableKeyDown(event: KeyboardEvent) {
        if (this.isEditing) {
            return;
        }

        const len: number = this.dataSource.filteredData.length;
        if (event.key === 'ArrowDown') {
            if (this.Idx < (len - 1)) {
                this.selectedRecord = this.dataSource.filteredData[++this.Idx];
                this.displayDetail(this.selectedRecord);
            }
        } else if (event.key === 'ArrowUp') {
            if (this.Idx > 0) {
                this.selectedRecord = this.dataSource.filteredData[--this.Idx];
                this.displayDetail(this.selectedRecord);
            }
        }
        this.setPagination(this.Idx, this.dataSource.filteredData.length);
    }

    validateFields(): boolean {

        this.strErr = '';
        const vr: ValidationResult = this.selectedRecord.validateRecord();

        if (vr.error.length > 0) {
            this.strErr = vr.error;
            DwUtils.setFocus(vr.focus_field);
            return false;
        }
        return true;
    }

    submitRecord() {

        this.selectedRecord = new Region();
        this.selectedRecord.id = this.id;
        this.selectedRecord.description = DwUtils.capitalize(this.description);
        this.selectedRecord.zipCode = this.zipCode;
        this.selectedRecord.county =  DwUtils.capitalize(this.county);

        this.strErr = '';

        if (!this.validateFields()) {
            return;
        }
        if (this.isAdd === true) {
            this.serviceDefService.createRegion(this.selectedRecord).subscribe(
                (result) => {
                    this.selectedRecord.id = result.id;
                    this.isEditing = false;
                    /*** add a transaction history record ***/
                    this.txService.createTransactionHistory('Regions', this.selectedRecord.id);
                },
                () => {
                    this.strErr = 'Error: The server could not add/submit this record';
                    return;
                }
            );
        } else {

            this.serviceDefService.updateRegion(this.selectedRecord).subscribe(
                () => {
                    this.isEditing = false;
                },
                () => {
                    this.strErr = 'Error: The server could not update this record';
                    this.selectedRecord = this.historyRecord;
                    return;
                });

            /*** add a transaction history record ***/
            this.txService.updateTransactionHistory(this.historyRecord,
                this.selectedRecord, 'Regions', this.selectedRecord.id);
        }
        this.updateSelectedRow();
    }

    /* Update the record in the table's data source - without refreshing it */
    updateSelectedRow(): void {
        if (this.isAdd === true) {
            // add the new record to the top.
            this.records.unshift(this.selectedRecord);
            this.dataSource.data = this.records;
            this.Idx = 0;
        } else {
            const i: number = this.records.findIndex(r => r.id === this.selectedRecord.id);
            this.records[i] = this.selectedRecord;
            this.dataSource.data = this.records;
        }
        this.dataSource.sort = this.sort;
    }

    onRowClicked(selected: any) {

        if (this.isEditing === true)
            return;

        this.selectedRecord = selected;
        this.selectRow();
        this.setPagination(this.Idx, this.dataSource.filteredData.length);
        this.displayDetail(this.selectedRecord);
    }

    cancelSubmitRecord() {
        this.strErr = '';
        this.isEditing = false;
        this.displayDetail(this.selectedRecord);
    }
}
